import React from "react";
import { Autocomplete as MUIAutocomplete } from "@mui/material";
import styled from "styled-components";

const StyledMUIAutocomplete = styled(MUIAutocomplete)`
  background-color: var(--colorPanel);
  width: 250px;
  max-width: 85vw;
  outline: 1px solid #767676 !important;
  border-radius: 8px;

  border: unset !important;

  &.Mui-focused {
    outline: 2px solid var(--primaryColor) !important;
  }

  &:hover:not(.Mui-focused) {
    outline: 2px solid #767676 !important;
  }

  fieldset {
    background: unset;
    box-shadow: unset;
    width: initial;
  }

  input {
    border: unset !important;
  }

  label[data-shrink="false"] {
    width: 175px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
  }

  label[data-shrink="true"] {
    width: 290px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
  }

  button {
    height: initial !important;
    min-width: initial !important;
  }

  [class*="MuiAutocomplete-inputRoot"] {
    padding: 2px 2px 2px 9px !important;
  }
`;

export const Autocomplete = (props) => {
  return <StyledMUIAutocomplete {...props} />;
};
